import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const MandatoryLeave = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 6H22V5C22 4.45 21.55 4 21 4C20.45 4 20 4.45 20 5V6H12V5C12 4.45 11.55 4 11 4C10.45 4 10 4.45 10 5V6H9C6.237 6 4 8.238 4 11V23C4 25.762 6.237 28 9 28H23C25.762 28 28 25.762 28 23V11C28 8.238 25.762 6 23 6ZM26 23C26 24.65 24.65 26 23 26H9C7.35 26 6 24.65 6 23V11C6 9.35 7.35 8 9 8H10V9C10 9.55 10.45 10 11 10C11.55 10 12 9.55 12 9V8H20V9C20 9.55 20.45 10 21 10C21.55 10 22 9.55 22 9V8H23C24.65 8 26 9.35 26 11V23Z" />
		<path d="M17.413 18L19.701 15.713C19.876 15.538 19.989 15.288 19.989 15C19.989 14.45 19.539 14 18.989 14C18.714 14 18.464 14.113 18.277 14.287L16.002 16.587L13.715 14.3C13.54 14.125 13.29 14.013 13.002 14.013C12.452 14.013 12.002 14.463 12.002 15.013C12.002 15.288 12.115 15.538 12.289 15.726L14.576 18.013L12.289 20.301C12.114 20.476 12.002 20.726 12.002 21.013C12.002 21.563 12.452 22.013 13.002 22.013C13.277 22.013 13.527 21.9 13.715 21.725L16.002 19.437L18.29 21.725C18.465 21.9 18.715 22.013 19.002 22.013C19.552 22.013 20.002 21.563 20.002 21.013C20.002 20.738 19.889 20.488 19.714 20.301L17.414 18.001L17.413 18Z" />
	</svg>
);

export default MandatoryLeave;
